// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { updateAccountApprovalsPreference } from 'services/ApprovalsService'
import {
  UpdateAccountApprovalsPreferenceV1,
  UpdateAccountApprovalsPreferenceV2,
} from 'types/approvals'
import { BaseErrorResponse } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useAccountApprovalsPreferenceMutation = () => {
  return useMutation({
    mutationFn: ({
      data,
    }: {
      data:
        | { preferences: UpdateAccountApprovalsPreferenceV1[] }
        | UpdateAccountApprovalsPreferenceV2
    }) => updateAccountApprovalsPreference(data),
    onError: (error: BaseErrorResponse) => {
      logSentryError(
        'Error from useAccountApprovalsPreferenceMutation - updateAccountApprovalsPreference',
        error
      )
    },
  })
}
